// extracted by mini-css-extract-plugin
export var closeButton = "_hn-1";
export var closeX = "_hn-3";
export var container = "_hn-0";
export var image = "_hn-2";